import { useEffect, useState } from "react";
import { api } from "../lib/api";

export function StyleSelect({ value, onChange }) {
  const [styles, setStyles] = useState([]);

  useEffect(() => {
    api.get("/styles").then((r) => setStyles(r.data)).catch(() => {});
  }, []);

  if (styles.length === 0) return null;

  return (
    <div>
      <label className="text-xs uppercase tracking-[0.15em] text-zinc-500">Brand style (optional)</label>
      <select data-testid="brand-style-select" value={value} onChange={(e) => onChange(e.target.value)}
        className="mt-2 w-full border border-zinc-300 rounded-md px-3.5 py-2.5 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-zinc-950">
        <option value="">No brand style</option>
        {styles.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
      </select>
    </div>
  );
}
